import { DataStorage } from '@wegic/common';
import { getPricingModalOrigin, getPricingModalPopoupType } from '@/services/pay/storage';
import {
  getPricingModalTrackingPayload,
  getResolvedPricingTrackingOrigin,
  type PricingModalTrackingContextOptions,
} from './trackingContextCore';

export { getPricingModalTrackingPayload, getResolvedPricingTrackingOrigin } from './trackingContextCore';
export type {
  PricingModalTrackingContextOptions,
  PricingModalTrackingPayloadInput,
} from './trackingContextCore';

/**
 * 使用调用方传入的 origin，并从 DataStorage 读取全局 source 后根据规则返回准确的origin。
 */
export function getResolvedPricingTrackingOriginFromStorage(origin?: string | null) {
  return getResolvedPricingTrackingOrigin(origin, DataStorage.getField('source'));
}

/**
 * 构建当前 Pricing Modal 使用的埋点上下文。
 * origin 和 popup 类型来自 Pricing Modal 的存储状态，source 来自 DataStorage。
 */
function buildPricingModalTrackingContext(options: PricingModalTrackingContextOptions = {}) {
  return getPricingModalTrackingPayload({
    ...options,
    source: DataStorage.getField('source'),
  });
}

/**
 * 获取当前 Pricing Modal 的埋点上下文。
 */
export function getPricingModalTrackingContext(options: PricingModalTrackingContextOptions = {}) {
  return buildPricingModalTrackingContext({
    ...options,
    origin: getPricingModalOrigin(),
    popoupType: getPricingModalPopoupType(),
  });
}
